import {useEffect, useRef, useState, useCallback} from "react";
import {useLang} from "@/common/Contexts/LanguageContext";

const Camera360New = (props) => {
    const changingContentRef = useRef();
    const [show360, setShow360] = useState(false);
    const lang = useLang();

    const cleanup360Script = () => {
        const scriptTag = document.querySelector(`script[data-spin="${props.id}"]`);
        if (scriptTag) {
            scriptTag.remove();
        }
    };

    const handleHTMLChange = useCallback(() => {
        setShow360(true);
    }, []);

    useEffect(() => {
        if (changingContentRef.current) {
            tryScript();
            changingContentRef.current.addEventListener("DOMSubtreeModified", handleHTMLChange);

            // Clean up on route change
            window.addEventListener('beforeunload', cleanup360Script);

            return () => {
                changingContentRef?.current?.removeEventListener("DOMSubtreeModified", handleHTMLChange);
                cleanup360Script();
                window.removeEventListener('beforeunload', cleanup360Script);
            };
        }
    }, []);

    useEffect(() => {
        const observer = new MutationObserver(() => {
            const spin360Hitbox = document.querySelector(".spin360-hitbox");
            const hideBtnNo360 = document.querySelector("#hideBtnNo360");
            const hideBtnNo360Mobile = document.querySelector("#hideBtnNo360Mobile");

            if (spin360Hitbox) {
                props.updateHas360(true);
                if (hideBtnNo360) hideBtnNo360.style.display = "flex";
                if (hideBtnNo360Mobile) hideBtnNo360Mobile.style.display = "flex";
            } else {
                if (hideBtnNo360) hideBtnNo360.style.display = "none";
                if (hideBtnNo360Mobile) hideBtnNo360Mobile.style.display = "none";
            }
        });

        observer.observe(changingContentRef.current, {childList: true, subtree: true});

        return () => {
            observer.disconnect();
        };
    }, [show360]);

    const tryScript = () => {
        cleanup360Script(); // Clean up any existing script before adding new one
        let scriptTag = document.createElement("script");
        scriptTag.type = "text/javascript";
        scriptTag.src = "https://static.instavid360.com/p/0.8.latest/spin360.lite.js";
        scriptTag.setAttribute("data-spin", `${props.id}`);
        scriptTag.setAttribute("data-quality", "h");
        scriptTag.setAttribute("data-lang", `${lang}`);
        scriptTag.setAttribute("data-gallery", "off");
        scriptTag.setAttribute("data-metrics", "0");
        document.getElementById("spin-div").appendChild(scriptTag);
    };

    return (
        <>
            <div id="hideMeIfNoData" dir="ltr">
                <div id="spin-div" ref={changingContentRef}></div>
            </div>
        </>
    );
}

export default Camera360New;
